module.exports = __webpack_public_path__ + "img/e8a4aa7ad6d38783a65f526a1a3aafbb.png";